import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/auth.service";
import { OfficeService } from "src/app/services/office.service";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";
import { debounceTime, distinctUntilChanged, startWith } from "rxjs/operators";

interface Office {
  id: string;
  name: string;
}

@Component({
  selector: "app-select-company",
  templateUrl: "./select-company.component.html",
  styleUrls: ["./select-company.component.scss"],
})
export class SelectCompanyComponent implements OnInit {
  companyForm: FormGroup;
  offices: Office[] = [];
  filteredOffices: Office[] = [];
  isLoading: boolean = false;
  searchTerm: string = "";
  userLogged: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastrService,
    private errorHandler: ErrorHandlerService,
    private officeService: OfficeService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.companyForm = this.fb.group({
      selectedCompany: ["", [Validators.required]],
      searchTerm: [""],
    });

    this.setupSearchFilter();
    this.loadOfficies();

    const user = history.state.user;
    this.userLogged = user;
  }

  private setupSearchFilter(): void {
    this.companyForm
      .get("searchTerm")
      ?.valueChanges.pipe(startWith(""), debounceTime(300), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.searchTerm = searchTerm;
        this.filterOffices();
      });
  }

  private filterOffices(): void {
    if (!this.searchTerm.trim()) {
      this.filteredOffices = [...this.offices];
    } else {
      this.filteredOffices = this.offices.filter((office) =>
        office.name.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
    }
  }

  private loadOfficies(): void {
    this.isLoading = true;
    this.officeService.findAll().subscribe({
      next: (offices) => {
        this.offices = offices;
        this.filteredOffices = [...offices];
        this.isLoading = false;
      },
      error: (error) => {
        this.errorHandler.handle(error, "Erro ao carregar lista de empresas.");
        this.isLoading = false;
      },
    });
  }

  selectCompany(companyId: string): void {
    this.companyForm.patchValue({ selectedCompany: companyId });
  }

  public proceed(): void {
    if (this.companyForm.invalid) {
      this.companyForm.markAllAsTouched();
      this.toast.error("Selecione uma empresa para avançar.");
      return;
    }

    this.isLoading = true;
    const selectedCompanyId = this.companyForm.get("selectedCompany")?.value;

    this.authService.selectOffice(selectedCompanyId).subscribe({
      next: (response) => {
        this.authService.saveToken(response.token);

        const roles = this.authService.getUserRoles();
        this.toast.success("Login efetuado com sucesso!");
        this.isLoading = false;

        roles.map((role) => {
          switch (role.name) {
            case "ROLE_ADMIN":
            case "ROLE_MANAGER":
            case "ROLE_SUPERVISOR":
              this.router.navigate(["/inicio/gerente"], {
                state: { user: this.userLogged },
              });
              return;
            case "ROLE_USER":
              this.router.navigate(["/inicio/usuario"], {
                state: { user: this.userLogged },
              });
              return;
            default:
              this.router.navigate(["/inicio/usuario"], {
                state: { user: this.userLogged },
              });
          }
        });
      },
      error: (error) => {
        this.errorHandler.handle(error, "Erro ao selecionar empresa.");
        this.isLoading = false;
      },
    });
  }
}
